import React from 'react';

const Footer = () => {
  return (
    <footer style={{ textAlign: 'center', marginTop: '20px' }}>
        <hr/>
      &copy; {new Date().getFullYear()} somatikai | <a href="mailto:somatikai@outlook.com">Send Feedback</a>
    </footer>
  );
};

export default Footer;
